import menuList from "constants/select/styles/menuList";
import option from "constants/select/styles/option";
import colors from "assets/css/colors";

const CONTROL_BORDER_COLOR = {
  filled: colors.white,
  outlined: colors.strokeGrey,
};
const CONTROL_SIZE = {
  sm: "32px",
  md: "38px",
  lg: "40px",
};
const CONTROL_BORDER_RADIUS = {
  sm: 2,
  md: 4,
};

const TEXT = {
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "19.6px",
  color: colors.mainBlack,
};

const BOX_SHADOW = `0 0 0 1px ${colors.strokeGrey}, 0 4px 11px hsla(0, 0%, 0%, 0.1)`;

const getBorderBySize = (size) => CONTROL_BORDER_RADIUS[size] ?? CONTROL_BORDER_RADIUS.md;

const getBorderColor = ({ menuIsOpen, variant }) => {
  if (menuIsOpen) return colors.mainBlue;

  return CONTROL_BORDER_COLOR[variant] || CONTROL_BORDER_COLOR.filled;
};

const getBorderRadius = ({ menuIsOpen, size }) => {
  const borderRadius = getBorderBySize(size);

  if (!menuIsOpen) return borderRadius;

  return `${borderRadius}px ${borderRadius}px 0 0`;
};

const getMinHeight = ({ size }) => CONTROL_SIZE[size] ?? CONTROL_SIZE.md;

export default {
  container: (styles) => ({
    ...styles,
    minWidth: "220px",
  }),
  control: (styles, { menuIsOpen, selectProps: { variant, size } }) => ({
    ...styles,
    outline: "none",
    borderColor: getBorderColor({ menuIsOpen, variant }),
    minHeight: getMinHeight({ size }),
    borderRadius: getBorderRadius({ menuIsOpen, size }),
    boxShadow: menuIsOpen && BOX_SHADOW,
    "&:hover": {
      borderColor: colors.mainBlue,
    },
  }),
  dropdownIndicator: (styles, { selectProps: { menuIsOpen } }) => ({
    ...styles,
    padding: "0 6px",
    rotate: menuIsOpen ? "180deg" : null,
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingTop: "1px",
    paddingBottom: "1px",
    ...TEXT,
  }),
  singleValue: (styles) => ({
    ...styles,
    ...TEXT,
  }),
  placeholder: (styles) => ({
    ...styles,
    ...TEXT,
    color: colors.grey,
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: 1001,
  }),
  menu: (styles, { selectProps: { size } }) => {
    const borderRadius = getBorderBySize(size);

    return {
      ...styles,
      margin: "1px 0 0",
      padding: 0,
      borderRadius: `0 0 ${borderRadius}px ${borderRadius}px`,
      boxShadow: BOX_SHADOW,
    };
  },
  menuList,
  option,
};
